import { inject, Pipe, PipeTransform } from '@angular/core';
import { LogsService } from '@services/logs';

@Pipe({
  name: 'consoleLog',
  standalone: true,
})
export class ConsoleLogPipe implements PipeTransform {
  readonly #logsService = inject(LogsService);

  transform<T>(value: T): T {
    this.#logsService.all('ConsoleLogPipe', 'value:', value);
    return value;
  }
}
